import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as NavLink } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import {
  TableContainer,
  Table,
  TableColumn,
  TableActions,
  Typography,
  Card,
} from '_template';
import ButtonDelete from 'components/ButtonDelete';
import { ROUTE } from 'constants/route';
import Link from 'components/Link';
import { useTableAttrs } from 'helpers/table/useTableAttrs';
import { RIGHTS } from 'constants/rights';
import {
  DeleteEmailTemplateMutation,
  GetEmailTemplateListQuery,
} from 'modules/EmailTemplate/query';

const EmailTemplateTable = () => {
  const { t } = useTranslation();
  const { queryLimits, queryOrderBy, tableProps } = useTableAttrs(
    'emailTemplate',
    {
      sortField: 'primary',
      sortBy: 'asc',
    }
  );

  const emailTemplateListQuery = useQuery(GetEmailTemplateListQuery, {
    variables: {
      limit: queryLimits,
      orderBy: queryOrderBy,
    },
    fetchPolicy: 'cache-and-network',
  });

  const { loading, data, error } = emailTemplateListQuery;

  const refetch = () => emailTemplateListQuery.refetch();

  const [deleteMutation] = useMutation(DeleteEmailTemplateMutation);

  return (
    <TableContainer component={Card}>
      <Table<GQL.IEmailTemplate>
        dataSource={data?.emailTemplateList?.rows}
        recordsCount={data?.emailTemplateList?.count}
        loading={loading}
        error={error}
        {...tableProps}
      >
        <TableColumn
          label={t('EMAIL_TEMPLATE.NAME')}
          dataIndex="name"
          sx={{
            width: {
              md: '50%',
            },
          }}
          render={(row: GQL.IEmailTemplate) => (
            <Link
              component={NavLink}
              to={ROUTE.EMAIL_TEMPLATE_DETAIL.replace(':recordId', row.id)}
              right={RIGHTS.EMAIL_TEMPLATE.EDIT}
            >
              <Typography>{row.name}</Typography>
            </Link>
          )}
        />
        <TableColumn
          label={t('EMAIL_TEMPLATE.ARTICLE')}
          dataIndex="article"
          sx={{
            display: {
              xs: 'none',
              md: 'table-cell',
            },
          }}
          render={(emailTemplate: GQL.IEmailTemplate) => (
            <Typography>{emailTemplate.article}</Typography>
          )}
        />
        <TableActions
          render={(row: GQL.IEmailTemplate) => {
            return (
              <ButtonDelete
                message={t('EMAIL_TEMPLATE.REALLY_TO_DELETE')}
                right={RIGHTS.EMAIL_TEMPLATE.DELETE}
                onDelete={() => deleteMutation({ variables: { id: row.id } })}
                refetch={refetch}
              />
            );
          }}
        />
      </Table>
    </TableContainer>
  );
};

export default EmailTemplateTable;
